import { inventorySlotQueryKeys as e } from "./useInventorySlotQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { inventorySlotsApi as n } from "@maat/api-main";
//#region src/inventorySlots/useListingSlotAvailabilityQuery.ts
var r = (r, i, a) => t({
	queryKey: e.listingAvailability(r, i, a),
	queryFn: () => n.getListingSlots(r, {
		...i,
		...a ? { seats: a } : {}
	}),
	enabled: !!r && !!i
});
//#endregion
export { r as useListingSlotAvailabilityQuery };
